import RbcGicFormV2 from './RbcGicFormNew/RbcGicFormStepper';

export default function RbcGicFormPage() {
  return <RbcGicFormV2 />;
}
